const SVG = () => (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_14811_13755)">
      <path
        d="M22.8451 20.7448H21.7956C21.2079 20.7448 20.7461 20.2725 20.7461 19.6953V14.4479C20.7461 13.8602 21.2079 13.3984 21.7956 13.3984H22.8451C23.9995 13.3984 24.944 14.3325 24.944 15.4974V18.6458C24.944 19.8003 23.9995 20.7448 22.8451 20.7448Z"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.20312 20.7448H8.15365C6.99397 20.7448 6.05469 19.8003 6.05469 18.6458V15.4974C6.05469 14.3325 6.99397 13.3984 8.15365 13.3984H9.20312C9.78034 13.3984 10.2526 13.8602 10.2526 14.4479V19.6953C10.2526 20.2725 9.78034 20.7448 9.20312 20.7448Z"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.321 13.401V12.8763C22.321 9.10867 19.267 6.05469 15.4993 6.05469C11.7317 6.05469 8.67773 9.10867 8.67773 12.8763V13.401"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.1549 25.2096H14.8431C14.119 25.2096 13.5312 24.6219 13.5312 23.8978C13.5312 23.1736 14.119 22.5859 14.8431 22.5859H16.1549C16.8791 22.5859 17.4668 23.1736 17.4668 23.8978C17.4668 24.6219 16.8791 25.2096 16.1549 25.2096Z"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.4609 23.8984H19.6858C20.8403 23.8984 21.7848 22.9539 21.7848 21.7995V20.75"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14811_13755">
        <rect
          width="25.1875"
          height="25.1875"
          fill="white"
          transform="translate(2.90625 2.90625)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SVG
